export const connectionTypes = ['DataLake', 'SQLServer', 'Databricks'] as const;

export type ConnectionType = 'DataLake' | 'SQLServer' | 'Databricks';

export enum ConnectionTypeEnum {
    DataLake = 'DataLake',
    SQLServer = 'SQLServer',
    Databricks = 'Databricks',
}
